import useSWR from 'swr';

import { MODELS_PATH } from '@api/paths';
import { IIdentity } from '@models/IIdentity';
import { IProtocol } from '@models/IProtocol';
import { fetcher } from '@utils/swr-utils';

export default function useProtocol(identity: IIdentity) {
  const { data, error, isLoading } = useSWR<IProtocol>(
    `${MODELS_PATH}/${identity.type}/${identity.module}/${identity.key}/${identity.version}`,
    fetcher
  );

  return { protocol: data, isLoading, isError: Boolean(error) };
}
